export default __webpack_public_path__ + "static/media/ic-notes-attachment-inactive.82e31f14.svg";